module.exports = __webpack_public_path__ + "img/rvt.bde4fa75.svg";